


















































































































































import {Vue, Component} from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import {toI18n} from '@/utils/commonUtils';

@Component({
  directives: {
    ClickOutside
  }
})
export default class ProductListContent extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr));
  }
  public showCustomProperty: boolean = true;
}
